import { useState } from 'react';
import { PageContentProcessTabs } from 'framework/ViewTypes/components';
import { ActiveProcesses } from 'framework/ViewTypes/embeddable';
import { EmployeeLinkWithNameLoading } from 'domain/shared/employee';
import { ActivatePositionFillRequestDrawer, ReviewPositionFillRequestDrawer } from '../../createupdate';
import { POSITION_FILL_REQUEST_STATUS } from '../../constants';
import type { PositionFillRequestListItem } from '../../types';

type PositionFillRequestActiveProcessesProps = {
  positionFillRequest: PositionFillRequestListItem;
  stateOwners?: Array<{ id: string; name?: string }>;
  canReview: boolean;
  canActivate: boolean;
  onUpdated: () => void;
};

const PositionFillRequestActiveProcesses = ({
  positionFillRequest,
  stateOwners = [{ id: positionFillRequest.ownerAlias, name: positionFillRequest.ownerAlias }],
  onUpdated,
  canReview,
  canActivate,
}: PositionFillRequestActiveProcessesProps) => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const isApproval = positionFillRequest.status === POSITION_FILL_REQUEST_STATUS.REQUESTED;
  const isActivation = positionFillRequest.status === POSITION_FILL_REQUEST_STATUS.PENDING;

  if (!isApproval && !isActivation) return null;

  const process = isApproval
    ? {
        id: 'position-fill-request-approval',
        title: 'Position fill request approval',
        description: 'The position fill request is awaiting approval before it can proceed to recruitment',
        actionLabel: 'Make decision',
      }
    : {
        id: 'position-fill-request-activation',
        title: 'Position fill request activation',
        description: 'The position fill request is approved and ready for recruitment activation',
        actionLabel: 'Activate request',
      };

  return (
    <>
      <PageContentProcessTabs
        tabs={[
          {
            id: 'active-processes',
            name: 'Active processes',
            panel: (
              <ActiveProcesses
                collapsible={false}
                renderOwner={owner => (
                  <EmployeeLinkWithNameLoading id={owner.id} name={owner.name} defaultValue={owner.id} />
                )}
                items={[
                  {
                    id: process.id,
                    title: process.title,
                    description: process.description,
                    // TODO Imlement SLA end date when it is available in the backend
                    // slaEndDate: ...,
                    owners: stateOwners,
                    action:
                      (isApproval && canReview) || (isActivation && canActivate)
                        ? {
                            id: `${process.id}-action`,
                            label: process.actionLabel,

                            onClick: () => setDrawerOpen(true),
                          }
                        : undefined,
                  },
                ]}
              />
            ),
          },
        ]}
      />

      {isApproval && isDrawerOpen && (
        <ReviewPositionFillRequestDrawer
          isOpen
          positionFillRequestId={positionFillRequest.id}
          onClose={() => setDrawerOpen(false)}
          onSuccess={onUpdated}
        />
      )}
      {isActivation && isDrawerOpen && (
        <ActivatePositionFillRequestDrawer
          isOpen
          positionFillRequestId={positionFillRequest.id}
          onClose={() => setDrawerOpen(false)}
          onSuccess={onUpdated}
        />
      )}
    </>
  );
};

export default PositionFillRequestActiveProcesses;
